import { mapGetters } from 'vuex'

import render from './render'

export default {
  name: 'Notification',

  computed: {
    ...mapGetters({
      newVersion: 'version/new',
      hasNewVersion: 'version/hasNewVersion'
    })
  },

  render
}
